import { proposalsService } from '@/services/proposals';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export interface ImprovementLetterData {
  text: string | null;
  attachments: { key: string; url: string }[];
}

/**
 * Busca o texto + anexo (mais recente) da carta de melhoria de uma policy.
 *
 * Usa o endpoint de proposta (`policies.proposals.read`), acessível a TODOS os
 * perfis — inclusive corretor/assessoria/CX, que não têm
 * `policies.inspections.read`. Por isso pode rodar independente do perfil.
 */
export function useImprovementLetter(
  policyId: string | undefined,
  options: { enabled?: boolean } = {}
) {
  return useQuery<ImprovementLetterData | null>({
    queryKey: ['improvement-letter', policyId],
    queryFn: async () => {
      if (!policyId) {
        throw new Error('PolicyId é obrigatório');
      }

      const response = await proposalsService.getImprovementLetter(policyId);
      if (!response.success || !response.data) {
        return null;
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
    enabled: !!policyId && (options.enabled ?? true),
    retry: false,
  });
}
